
(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('overlayDemo', ['$document', '$window', '$sce', 'hubspotService', function ($document, $window, $sce, hubspotService) {
            return {
                restrict: 'E',
                templateUrl: '/templates/global/overlay-demo.html?v=' + config.version,
                scope: true,
                link: function (scope) {
                    const formTarget = '#hspot-demo';
                    // confirmation page to display in the overlay
                    scope.confirmURL = $window.config.baseUrl + '/interest-confirmation';
                    console.log(scope.confirmURL);

                    scope.$on('open-demo-overlay', function () {
                        scope.formSubmitted = false;
                        // TODO: support multiple demo types?

                        // if the form hasn't already been loaded
                        if ($document[0].querySelector(`${formTarget} > form`) === null) {
                            console.log('loading form');
                            hubspotService.loadDemoForm({
                                target: formTarget,
                                onFormSubmit: scope.onFormSubmit,
                                onFormSubmitted: scope.onFormSubmitted,
                            });
                        }

                        scope.open();
                    });

                    scope.$on('close-overlay', function () {
                        // reset?
                    });

                    scope.onFormSubmit = ($form) => {
                        const formData = new $window.FormData($form);

                        ChiliPiper.submit('thankview', 'demo', {
                            map: true,
                            lead: {
                                FirstName: formData.get('firstname'),
                                LastName: formData.get('lastname'),
                                Email: formData.get('email'),
                                Phone: formData.get('phone'),
                            },
                        });
                    };

                    scope.onFormSubmitted = () => {
                        scope.formSubmitted = true;
                        scope.$apply();
                    };
                },
            };
        }]);
}());
